import wardReports from "../components/views/wasteReports/ward_collection_reports.vue";
import scanCardReports from "../components/views/wasteReports/scan_card_reports.vue";
import tripReports from "../components/views/wasteReports/vehicle_trip_reports.vue";
import reportView from "../components/views/wasteReports/reportView.vue";
import cityCollectionReports from "../components/views/wasteReports/city_collection_reports.vue";
import lineCollectionReports from "../components/views/wasteReports/line_collection_reports.vue";
import monthlyCityCollectionReports from "../components/views/wasteReports/monthly_city_collection_reports.vue";

const routes = [
  {
    path: "ward-reports",
    component: wardReports,
    name: "wardReports",
    meta: {
      description: "",
      title: "Ward Collection Reports",
      requiresAuth: true,
    },
  },
  {
    path: "card-reports",
    component: scanCardReports,
    name: "scanCardReports",
    meta: {
      description: "",
      title: "Scan Card Reports",
      requiresAuth: true,
    },
  },
  {
    path: "trip-reports",
    component: tripReports,
    name: "tripReports",
    meta: {
      description: "",
      title: "Vehicle Trip Reports",
      requiresAuth: true,
    },
  },
  {
    path: "view",
    component: reportView,
    name: "reportView",
    meta: {
      description: "",
      title: "Reports",
      requiresAuth: true,
    },
  },
  {
    path: "city_collection_reports",
    component: cityCollectionReports,
    name: "cityReports",
    meta: {
      description: "",
      title: "City Collection Reports",
      requiresAuth: true,
    },
  },
  {
    path: "line_collection_reports",
    component: lineCollectionReports,
    name: "lineReports",
    meta: {
      description: "",
      title: "Line Collection Reports",
      requiresAuth: true,
    },
  },
  {
    path: "monthly_city_collection_reports",
    component: monthlyCityCollectionReports,
    name: "monthlyCityReports",
    meta: {
      description: "",
      title: "Monthly City Reports",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/reports.route.js